module.exports = __webpack_public_path__ + "images/category_lp/art_work/assessment_achievements/1_a2244142e8652af37b785b74223ed69d.jpg";